import createHistory from 'history/createBrowserHistory';
import Configs from './configs';

const history = createHistory();
if (process.env.REACT_APP_ENV === 'production' && Configs.GOOGLE_ANALYTICS.ENABLE) {
    history.listen((location) => {
        try {
            window.gtag('config', Configs.GOOGLE_ANALYTICS.TRACKING_ID, {
                page_path: location.pathname,
            });
        } catch (error) {
            console.log('Error en gtag');
            console.log(error);
        }
    });
}

/*
  This is the history object used to initialize store and also supplied into
  the router component.
*/
export default history;



/** WEBPACK FOOTER **
 ** ./src/browser-history.jsx
 **/